// DS: i3.4
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const ChevronRight: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.0533 2.28508L11.003 7.23483C11.3936 7.62535 11.3936 8.25852 11.003 8.64904L6.0533 13.5988C5.66277 13.9893 5.02961 13.9893 4.63908 13.5988C4.24856 13.2083 4.24856 12.5751 4.63908 12.1846L8.88119 7.94119L4.63908 3.69929C4.24856 3.30877 4.24856 2.67561 4.63908 2.28508C5.02961 1.89456 5.66277 1.89456 6.0533 2.28508Z"
      />
    </svg>
  </IconWrap>
);
ChevronRight.displayName = 'ChevronRight';

export default ChevronRight;
